import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Calendar, Clock, User, ArrowRight, Tag } from 'lucide-react';

const blogPosts = [
  {
    id: 1,
    title: 'Getting Started with Large Language Models in 2026',
    excerpt: 'A comprehensive guide to understanding and working with the latest LLMs, including GPT-5, Claude, and open-source alternatives.',
    author: 'Dr. Sarah Chen',
    date: 'January 15, 2026',
    readTime: '8 min read',
    category: 'Tutorial',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=600'
  },
  {
    id: 2,
    title: 'The State of Computer Vision: What\'s New in 2026',
    excerpt: 'Exploring the latest breakthroughs in computer vision, from multimodal models to real-time video understanding.',
    author: 'Prof. Michael Roberts',
    date: 'January 10, 2026',
    readTime: '6 min read',
    category: 'Industry Trends',
    image: 'https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=600'
  },
  {
    id: 3,
    title: 'From Bootcamp to ML Engineer: A Success Story',
    excerpt: 'How one of our students went from zero coding experience to landing a six-figure ML engineering role at a top tech company.',
    author: 'WSafe AI ML Team',
    date: 'January 5, 2026',
    readTime: '5 min read',
    category: 'Success Stories',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600'
  },
  {
    id: 4,
    title: 'Building Production-Ready ML Pipelines',
    excerpt: 'Learn best practices for taking your ML models from notebook to production with modern MLOps tools.',
    author: 'James Wilson',
    date: 'December 28, 2025',
    readTime: '10 min read',
    category: 'MLOps',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600'
  },
  {
    id: 5,
    title: 'AI Ethics: Building Responsible AI Systems',
    excerpt: 'A deep dive into the ethical considerations every AI practitioner should understand.',
    author: 'Dr. Priya Sharma',
    date: 'December 20, 2025',
    readTime: '7 min read',
    category: 'AI Ethics',
    image: 'https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=600'
  },
  {
    id: 6,
    title: '10 Python Libraries Every ML Engineer Should Know',
    excerpt: 'Essential tools for data manipulation, model building, and deployment that will supercharge your workflow.',
    author: 'Dr. Sarah Chen',
    date: 'December 15, 2025',
    readTime: '6 min read',
    category: 'Tools',
    image: 'https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=600'
  }
];

const categories = ['All', 'Tutorial', 'Industry Trends', 'Success Stories', 'MLOps', 'AI Ethics', 'Tools'];

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = React.useState('All');

  const filteredPosts = selectedCategory === 'All' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  return (
    <div className="page blog-page">
      <Header onEnrollClick={() => window.location.href = '/pricing'} />
      
      <main className="page-content">
        <section className="page-hero blog-hero">
          <div className="container">
            <span className="section-tag">Learn & Grow</span>
            <h1 className="page-title">WSafe AI ML Blog</h1>
            <p className="page-subtitle">
              Insights, tutorials, and stories from the world of AI & Machine Learning
            </p>
          </div>
        </section>

        {/* Categories */}
        <section className="blog-categories">
          <div className="container">
            <div className="categories-list">
              {categories.map((category) => (
                <button
                  key={category}
                  className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                  onClick={() => setSelectedCategory(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Posts */}
        <section className="blog-posts-section">
          <div className="container">
            <div className="blog-grid">
              {filteredPosts.map((post) => (
                <article key={post.id} className="blog-card">
                  <div className="blog-image-wrapper">
                    <img src={post.image} alt={post.title} className="blog-image" />
                    <span className="blog-category-tag">
                      <Tag size={12} /> {post.category}
                    </span>
                  </div>
                  <div className="blog-content">
                    <h3 className="blog-title">{post.title}</h3>
                    <p className="blog-excerpt">{post.excerpt}</p>
                    <div className="blog-meta">
                      <span><User size={14} /> {post.author}</span>
                      <span><Calendar size={14} /> {post.date}</span>
                      <span><Clock size={14} /> {post.readTime}</span>
                    </div>
                    <Button className="btn-secondary blog-read-btn">
                      Read More <ArrowRight size={16} />
                    </Button>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter CTA */}
        <section className="blog-cta">
          <div className="container">
            <div className="cta-card">
              <h2>Stay Updated</h2>
              <p>Get the latest articles delivered to your inbox</p>
              <Link to="/#newsletter">
                <Button className="btn-primary">Subscribe to Newsletter</Button>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default BlogPage;
